module.exports = __webpack_public_path__ + "static/media/pokemon-Home.b4e75f99.png";